export interface Quote {
  _id: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  city: string;
  selectedProducts: string[];
  status: "New" | "In Progress" | "Resolved" | "Closed";
  replies: { message: string; repliedAt: string; _id?: string }[];
  createdAt: string;
  updatedAt: string;
}

// Local storage functions - no backend dependency
const STORAGE_KEY = 'ss_plastic_quotes';

export async function createQuote(quoteData: Omit<Quote, "_id" | "createdAt" | "updatedAt" | "replies" | "status">): Promise<Quote> {
  await new Promise(resolve => setTimeout(resolve, 300));
  
  const stored = localStorage.getItem(STORAGE_KEY);
  const quotes: Quote[] = stored ? JSON.parse(stored) : [];
  
  const newQuote: Quote = {
    ...quoteData,
    _id: Date.now().toString(),
    status: 'New',
    replies: [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  
  quotes.push(newQuote);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(quotes));
  
  return newQuote;
}